<script setup lang="ts">
/** 문서 스코프 provider — 감싼 문서의 CddVarField 들이 'scope/키' 로 네임스페이스되게 함. */
import { provide } from 'vue';
import { DOC_SCOPE } from './useCddFill';
const props = defineProps<{ scope: string }>();
provide(DOC_SCOPE, props.scope);
</script>

<template>
  <slot />
</template>
